import React from 'react';
import ModalMC from './ModalMC';

const ConfirmModalMC = ({
  visible,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'PRIMARY',
  loading = false,
  onConfirm,
  onClose
}) => (
  <ModalMC
    visible={visible}
    title={title}
    onClose={onClose}
    closeOnEsc={!loading}
    closeOnOverlayClick={!loading}
    buttons={[
      {
        label: cancelLabel,
        onClick: onClose,
        variant: 'SECONDARY',
        disabled: loading
      },
      {
        label: confirmLabel,
        onClick: onConfirm,
        variant,
        disabled: loading
      }
    ]}
  >
    <p className="tw-text-sm tw-leading-6 tw-text-gray-600">{description}</p>
  </ModalMC>
);

export default ConfirmModalMC;
